<template>
  <section class="pricing__area pt-100 pb-110">
    <div class="container">
      <div class="row mb-60">
        <div class="col-12">
          <div class="sec-wrapper text-center">
            <h5>Çmimorja</h5>
            <h2 class="section-title">Pakot aktive</h2>
            <p class="section-desc">Pakot për Përdorim Personal<br>Të vlefshme për automjete private që përdoren për nevoja personale dhe jo për qëllime biznesi</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          v-for="(pricing, idx) in activePackages"
          :key="pricing.Id"
          class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6"
        >
          <div class="pricing__item text-center transition-3 mb-30" :style="{ animationDelay: (idx * 80) + 'ms' }">
            <div
              v-if="pricing.Discount && pricing.Discount > 0"
              class="discount-badge"
              aria-hidden="false"
            >
              Zbritje {{ pricing.Discount }}%
            </div>
            <div class="pricing__header mb-25">
              <h3>{{ pricing.Title }}</h3>
              <p><span v-html="pricing.Description"></span></p>
            </div>
            <div class="pricing__tag d-flex align-items-start justify-content-center mb-30">
              <span></span>
              <h4>{{ pricing.Price }} € </h4>
            </div>
            <h3>Për një vit</h3>
            <div class="pricing__header mb-25">
              <h3>(Pa limit asistime)</h3>
            </div>
            <div class="pricing__switch mb-10">
              <button type="button">Përfito nga çmimi promocional</button>
            </div>
            <div class="pricing__buy mb-20">
              <router-link
                :to="{ name: 'antaresohu', params: { id: pricing.Id } }"
                class="tp-btn w-100"
              >
                Antarsohu
              </router-link>
            </div>
            <div class="pricing__features text-start">
              <ul>
                <li>24/7 Asistencë</li>
                <li>Asistencë në ndërrim të gomës</li>
                <li>Asistencë në ndezje të veturës me kabllo</li>
                <li>Bartje të automjetit sipas kërkesës</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- Commercial packages (same card style) -->
      <div v-if="commercialPackages.length" class="row mt-60">
        <div class="col-12">
          <div class="sec-wrapper text-center">
            <h5>Çmimorja</h5>
            <h2 class="section-title">Pakot Komerciale</h2>
            <p class="section-desc">Pakot komerciale vlejnë për automjete N1 dhe mjete pune për biznes, përfshirë furgona, pikapa, taxi, rent-a-car dhe mjete transporti profesional deri në 3,500 kg.</p>
          </div>
        </div>
      </div>
      <div v-if="commercialPackages.length" class="row">
        <div
          v-for="(pricing, idx) in commercialPackages"
          :key="pricing.Id+'_c'"
          class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6"
        >
          <div class="pricing__item text-center transition-3 mb-30" :style="{ animationDelay: (idx * 80) + 'ms' }">
            <div
              v-if="pricing.Discount && pricing.Discount > 0"
              class="discount-badge"
              aria-hidden="false"
            >
              Zbritje {{ pricing.Discount }}%
            </div>
            <div class="pricing__header mb-25">
              <h3>{{ pricing.Title }}</h3>
              <p><span v-html="pricing.Description"></span></p>
            </div>
            <div class="pricing__tag d-flex align-items-start justify-content-center mb-30">
              <span></span>
              <h4>{{ pricing.Price }} € </h4>
            </div>
            <h3>Për një vit</h3>
            <div class="pricing__header mb-25">
              <h3>(Pa limit asistime)</h3>
            </div>
            <div class="pricing__switch mb-10">
              <button type="button">Përfito nga çmimi promocional</button>
            </div>
            <div class="pricing__buy mb-20">
              <router-link
                :to="{ name: 'antaresohu', params: { id: pricing.Id } }"
                class="tp-btn w-100"
              >
                Antarsohu
              </router-link>
            </div>
            <div class="pricing__features text-start">
              <ul>
                <li>24/7 Asistencë</li>
                <li>Asistencë në ndërrim të gomës</li>
                <li>Asistencë në ndezje të veturës me kabllo</li>
                <li>Bartje të automjetit sipas kërkesës</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PricingArea',
  computed: {
    ...mapGetters('offers', ['offers']), // map the offers getter to this.offers
    pricingData() {
      return this.offers; // use pricingData in the template
    }
    ,
    activePackages() {
      return (this.pricingData || []).filter(p => !p.CommercialPackage);
    },
    commercialPackages() {
      return (this.pricingData || []).filter(p => p.CommercialPackage);
    }
  },
  created() {
    this.$store.dispatch('offers/fetchOffers');
  }
};
</script>

<style scoped>
.pricing__item {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid rgba(34,34,34,0.06);
  border-radius: 12px;
  transition: transform 240ms ease, box-shadow 240ms ease, border-color 240ms ease;
  background: #fff;
  opacity: 0;
  transform: translateY(12px);
  animation: fadeSlideUp 420ms cubic-bezier(.2,.9,.3,1) forwards;
}
.discount-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(135deg,#ff5a5f,#ff8966);
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 13px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
  transform: rotate(-6deg);
  transform-origin: right top;
  z-index: 4;
}

@media (max-width: 576px) {
  .discount-badge {
    top: 8px;
    right: 8px;
    font-size: 12px;
    padding: 5px 8px;
    transform: rotate(-4deg);
  }
}

/* Ensure the card content flows vertically and footer area sticks to bottom */
.pricing__features {
  margin-top: auto;
}

/* Make sure the column stretches so .pricing__item 100% height works */
.col-xxl-4, .col-xl-4, .col-lg-4, .col-md-6, .col-sm-6 {
  display: flex;
  flex-direction: column;
}

/* Hover animation and accent border */
.pricing__item:hover {
  transform: translateY(-8px) scale(1.01);
  box-shadow: 0 12px 30px rgba(8,31,63,0.12);
  border-color: #ff5a5f;
}

.pricing__item .pricing__header h3 {
  transition: color 200ms ease;
}
.pricing__item:hover .pricing__header h3 {
  color: #ff3b30;
}

/* Entrance animation */
@keyframes fadeSlideUp {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
<style scoped>
.section-desc {
  color: #6c757d;
  margin-top: 12px;
  margin-bottom: 18px;
  font-size: 0.95rem;
  line-height: 1.4;
}
</style>
